import {nanoid} from "nanoid";
import { CompassOutlined, FireOutlined, DollarOutlined } from '@ant-design/icons';

const stats = [
    {
        id: nanoid(),
        icon: <FireOutlined />,
        title: "Missions",
        value: "3 000"
    },
    {
        id: nanoid(),
        icon: <DollarOutlined />,
        title: "Paid to Delegate",
        value: "1 530"
    },
    {
        id: nanoid(),
        icon: <DollarOutlined />,
        title: "Paid to BTHERE",
        value: "300"
    },
    {
        id: nanoid(),
        icon: <CompassOutlined />,
        title: "CO2 Tons Saved",
        value: "302 095"
    },
];

export const searchFunction = (data, value) => {
    const search = value.toLowerCase();
    const hits = data.hits.filter(({users}) => {
        const {client, delegate} = users;

        if(client) {
            const clientName = `${client.last_name}, ${client.first_name}`.toLowerCase();
            if(clientName.includes(search)) {
                return true;
            }
        }
        if(delegate) {
            const delegateName = `${delegate.last_name}, ${delegate.first_name}`.toLowerCase();
            if(delegateName.includes(search)) {
                return true;
            }
        }
        return false;
    })
    return {...data, hits}
}

export const createAddressOptions = ((data = []) => {
    const unique = new Set(data);
    return [...unique].map(value => ({value, text: value, id: nanoid()}));
});

export const getResultData = (data, search, countries = [], cities = []) => {
    const searchData = search ? searchFunction(data, search) : data;
    const countryHits = countries.length ? searchData.hits.filter(({address_country}) => countries.includes(address_country)) : searchData.hits;
    const cityHits = cities.length ? countryHits.filter(({address_city}) => cities.includes(address_city)) : countryHits;
    return {...searchData, hits: cityHits};
}


export default stats;
